import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import {
  CreateProposalClientRequest,
  CreateProposalClientResponse,
} from '../../../@types/CreateProposal'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import { ENV } from '../../../Environment'
import { api } from '../../../Services/API'
import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { useErrorRequest } from '../../useErrorRequest'

const headers = {
  'aip-company': ENV().CreateProposal.Company,
  'aip-channel': ENV().CreateProposal.Channel,
}

const request = async (payload: CreateProposalClientRequest) => {
  const response = await api.post<CreateProposalClientResponse>(
    API_ROUTES.createProposal,
    payload,
    {
      headers,
    },
  )

  return response.data
}

export const useCreateProposal = () => {
  const { setCreateProposal, setHasCreatedProposal } = useCreateProposalStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: CreateProposalClientRequest) => request(payload!),
    onSuccess(data) {
      setCreateProposal(data)
      setHasCreatedProposal(true)
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
